import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20living%20room%20with%20soft%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20fresh%20flowers%20in%20a%20ceramic%20vase%20on%20a%20coffee%20table%2C%20a%20cozy%20throw%20blanket%20on%20a%20cream%20sofa%2C%20minimalist%20elegant%20interior%20design%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20soft%20feminine%20aesthetic%2C%20peaceful%20home%20atmosphere%2C%20high%20quality%20interior%20photography&width=1800&height=900&seq=hero-main-bg&orientation=landscape"
          alt="温暖的家居氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-sm md:text-base text-white/80 tracking-widest mb-4 font-label uppercase">
          第一次的人妻
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-6">
          新婚妻子角色转变
          <br />
          <span className="text-accent-300">全攻略</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          面对从"女友"到"妻子"的身份转变，你是否感到迷茫与不安？
          这里为你准备了角色适应、家庭经营、夫妻沟通与自我成长的系统化指南，
          帮助每一位第一次的人妻从容迈入婚姻新阶段。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/juese-shiying"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始阅读指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-white/15 text-white border border-white/30 font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}